"use client";

import { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import ReactStars from "react-rating-stars-component";
import { Icons } from "@/components/icons";
import { axiosInstance } from "@/lib/axios";
import { useRouter } from "next/navigation";

export default function Content({ profile }: { profile: any }) {
      const [event, setEvent] = useState<any[]>([]);
      const [statistic, setStatistic] = useState<any>([]);
      const [eventsLater, setEventsLater] = useState<any[]>([]);
      const [type, setType] = useState<any>('ongoing');
      const [isFollowing, setIsFollowing] = useState(false);
      const [isLiked, setIsLiked] = useState(false);

      // Loading state
      const [loading, setLoading] = useState(false);

      // Fetch data
      const fetchEvents = async () => {
            setLoading(true);
            try {
                  const [data] = await Promise.all([
                  fetch(`${process.env.NEXT_PUBLIC_CORE_BASEURL}/api/profiles/${profile.slug}/events?type=${type}`)
                  ]);

                  const pastData = await data.json();
                  setEvent(pastData || []);
            } catch (err) {
                  console.error("Failed to fetch events:", err);
            } finally {
                  setLoading(false);
            }
      };

      // Fetch data
      const fetchStatistic = async () => {
            setLoading(true);
            try {
                  const [data] = await Promise.all([
                  fetch(`${process.env.NEXT_PUBLIC_CORE_BASEURL}/api/profiles/${profile.slug}/statistic`)
                  ]);

                  const pastData = await data.json();
                  console.log(pastData);
                  setStatistic(pastData || []);
                 
            } catch (err) {
                  console.error("Failed to fetch events:", err);
            } finally {
                  setLoading(false);
            }
      };

      // Fetch data
      const fetchStatisticAuth = async () => {
            setLoading(true);
            try {
                   // Ambil CSRF Token dulu (wajib kalau Sanctum)
                  await axiosInstance.get("/sanctum/csrf-cookie");

                  // Panggil API follow
                  const res = await axiosInstance.get(
                        `/api/profiles/${profile.slug}/statisticAuth`
                  );
                  if (res.status === 200) {
                        setIsFollowing((prev) => {
                        const newStatus = !prev;

                        setIsFollowing(res.data.is_following);
                        setIsLiked(res.data.is_liked);

                        return newStatus;
                        });
                  }
            } catch (err) {
                  console.error("Failed to fetch events:", err);
            } finally {
                  setLoading(false);
            }
      };

      useEffect(() => {
            if(profile){
                  fetchEvents();
                  fetchStatistic();
                  fetchStatisticAuth();
            }
      }, [profile, type]);

      const ratingChanged = (newRating: any) => {
            console.log(newRating);
      };

      const handleShare = async () => {
            if (navigator.share) {
                  try {
                        await navigator.share({
                        title: profile.name,
                        text: `Lihat profil ${profile.name} di platform kami!`,
                        url: window.location.href,
                        });
                  } catch (err) {
                        console.error("Share canceled or failed:", err);
                  }
            } else {
                  alert("Browser tidak mendukung Web Share API");
            }
      };

      const router = useRouter();
      const handleLike = async () => {
            try {
                  // Ambil CSRF Token dulu (wajib kalau Sanctum)
                  await axiosInstance.get("/sanctum/csrf-cookie");

                  // Panggil API follow
                  const res = await axiosInstance.post(
                        `/api/profiles/${profile.slug}/like`
                  );

                  if (res.status === 200) {
                        setIsLiked((prev) => {
                        const newStatus = !prev;

                        // Update follower count
                        fetchStatistic();

                        return newStatus;
                        });
                  }
            } catch (err) {
                  console.error("Failed to follow:", err);
                  alert("Login terlebih dahulu");
                  router.push("/"); // redirect ke halaman login / home
            }
      };

      const handleFollow = async () => {
            try {
                  // Ambil CSRF Token dulu (wajib kalau Sanctum)
                  await axiosInstance.get("/sanctum/csrf-cookie");

                  // Panggil API follow
                  const res = await axiosInstance.post(
                        `/api/profiles/${profile.slug}/follow`
                  );

                  if (res.status === 200) {
                        setIsFollowing((prev) => {
                        const newStatus = !prev;

                        // Update follower count
                        fetchStatistic();

                        return newStatus;
                        });
                  }
            } catch (err) {
                  console.error("Failed to follow:", err);
                  alert("Login terlebih dahulu");
                  router.push("/"); // redirect ke halaman login / home

            }
      };

  return (
     <>
            <div>
                  <div className="fixed dark:hidden inset-x-0 top-0 pointer-events-none -z-10">
                        <Image
                              src="/event-background.png"
                              className="object-cover w-full scaleinout"
                              alt="pattern"
                              width={1000}
                              height={1000}
                        />
                  </div>
                  <div className="hidden dark:block dark:fixed inset-x-0 top-[-150px] pointer-events-none -z-10">
                        <Image
                              src="/background-dark.png"
                              className="object-cover w-full scaleinout"
                              alt="pattern"
                              width={1000}
                              height={1000}
                        />
                  </div>
                  <main className="max-w-[520px] mx-auto w-full text-white py-8 pb-8 min-h-screen px-3">
                        <div className="overflow-hidden rounded-2xl">
                              <div className="aspect-[496/289] relative">
                                    {profile.profile_background_path ? (
                                          <Image
                                                src={`${process.env.NEXT_PUBLIC_DASHBOARD_BASEURL}/storage/${profile.profile_background_path}`}
                                                className="object-cover w-full h-full"
                                                alt={profile.name}
                                                style={{
                                                      objectFit: "cover",
                                                      // objectPosition: "top",
                                                }}
                                                width={1000}
                                                height={1000}
                                          />
                                    ) : (
                                          <Image
                                                src="/no-image.jpg"
                                                className="object-cover w-full h-full"
                                                alt={profile.name}
                                                style={{
                                                      objectFit: "cover",
                                                      // objectPosition: "top",
                                                }}
                                                width={1000}
                                                height={1000}
                                          />
                                    )}
                                    {profile.profile_photo_path ? (
                                          <div className='absolute bottom-[-48px] left-[30px] w-[96px] h-[96px] rounded-full border-2 border-theme-accent p-[5px]'>
                                                <Image
                                                      src={`${process.env.NEXT_PUBLIC_DASHBOARD_BASEURL}/storage/${profile.profile_photo_path}`}
                                                      alt={profile.name}
                                                      width={86}
                                                      height={86}
                                                      className='w-full h-full object-cover rounded-full'
                                                />
                                          </div>
                                    ) : (
                                          <div className='absolute bottom-[-48px] left-[30px] w-[96px] h-[96px] rounded-full border-2 border-theme-accent p-[5px]'>
                                                <Image
                                                      src="/no-image.jpg"
                                                      alt={profile.name}
                                                      width={1000}
                                                      height={1000}
                                                      className='w-full h-full object-cover rounded-full'
                                                />
                                          </div>
                                    )}
                              </div>
                              <div className="pb-6 pt-[70px] bg-theme-black2 dark:bg-theme-dark_card">
                                    <div className='px-6 flex items-center justify-between'>
                                          <div className='flex flex-col'>
                                                <h2 className='font-bold lg:text-2xl text-base leading-[120%] tracking-[0.5%] text-white dark:text-theme-dark flex items-center gap-x-[6px]'>
                                                      { profile.name }
                                                      <span><Icons.verified className='lg:w-5 w-4 lg:h-5 h-4 text-theme-accent' /></span>
                                                </h2>
                                                <p className='font-medium lg:text-sm text-xs leading-[120%] tracking-[0.5%] text-theme-gray'>Identitas lembaga terverifikasi</p>
                                          </div>
                                    </div>
                                    <div className='px-6 flex items-center justify-between mt-6'>
                                          <button
                                                onClick={handleLike}
                                                className="bg-[#292F36] dark:bg-theme-dark_card3 flex items-center py-[5px] px-[10px] rounded-[4px] justify-center gap-x-2"
                                          >
                                                <Icons.like className={`w-[18px] h-[18px] ${isLiked ? "text-theme-accent" : "text-white dark:text-theme-dark"}`} />
                                          <h2 className="font-medium text-xs leading-[120%] tracking-[0.5%] text-white dark:text-theme-dark">
                                                {isLiked ? "Liked" : "Like"}
                                          </h2>
                                          </button>

                                          <div className='flex items-center gap-x-2'>
                                               <button onClick={handleFollow} className="bg-[#292F36] dark:bg-theme-dark_card3 flex items-center py-[5px] px-[10px] rounded-[4px] justify-center gap-x-2">
                                                      <Icons.checkFilled className={`w-[18px] h-[18px] ${isFollowing ? "text-theme-accent" : "text-white dark:text-theme-dark"}`} />
                                                      <h2 className="font-medium text-xs leading-[120%] tracking-[0.5%] text-white dark:text-theme-dark">
                                                            {isFollowing ? "Following" : "Follow"}
                                                      </h2>
                                                </button>

                                                <button onClick={handleShare} className='bg-[#292F36] dark:bg-theme-dark_card3 flex items-center py-[5px] px-[10px] rounded-[4px] justify-center gap-x-2'>
                                                      <Icons.share className='w-[18px] h-[18px] text-white dark:text-theme-dark' />
                                                      <h2 className='font-medium text-xs leading-[120%] tracking-[0.5%] text-white dark:text-theme-dark'>Bagikan</h2>
                                                </button>
                                          </div>
                                    </div>
                                    <div className='px-6 grid grid-cols-3 mt-6'>
                                          <div className='w-full col-span-1 flex flex-col gap-y-2 items-center justify-center'>
                                                <h2 className='font-bold lg:text-2xl text-base leading-[120%] tracking-[0.5%] text-theme-gray'>{statistic.event}</h2>
                                                <p className='font-medium lg:text-base text-sm leading-[120%] tracking-[0.5%] text-theme-gray'>Event</p>
                                          </div>
                                          <div className='w-full col-span-1 flex flex-col gap-y-2 items-center justify-center'>
                                                <h2 className='font-bold lg:text-2xl text-base leading-[120%] tracking-[0.5%] text-theme-gray'>{statistic.follower}</h2>
                                                <p className='font-medium lg:text-base text-sm leading-[120%] tracking-[0.5%] text-theme-gray'>Followers</p>
                                          </div>
                                          <div className='w-full col-span-1 flex flex-col gap-y-2 items-center justify-center'>
                                                <h2 className='font-bold lg:text-2xl text-base leading-[120%] tracking-[0.5%] text-theme-gray'>{statistic.like}</h2>
                                                <p className='font-medium lg:text-base text-sm leading-[120%] tracking-[0.5%] text-theme-gray'>Likes</p>
                                          </div>
                                    </div>
                                    <div className='px-6 flex flex-col gap-y-2 mt-6'>
                                          <p className='font-semibold lg:text-base text-sm text-theme-gray'>{ profile.bio }</p>
                                          <div className='flex items-center gap-x-[14px]'>
                                                <ReactStars
                                                      count={5}
                                                      size={16}
                                                      isHalf={true}
                                                      edit={false}
                                                      value={0}
                                                      emptyIcon={<Icons.emptystars />} // Outline star icon
                                                      halfIcon={<Icons.emptystars style={{ color: "#FACC15", opacity: 0.5 }} />} // Half-filled star icon
                                                      fullIcon={<Icons.fullstars />} // Fully filled star icon
                                                      activeColor="#FACC15"
                                                />
                                                <h2 className='font-bold lg:text-sm text-xs leading-[120%] tracking-[0.5%] text-theme-gray'>{statistic.review} Reviews</h2>
                                          </div>
                                    </div>
                                    <div className='grid grid-cols-3 items-center justify-between mt-10'>
                                          <div onClick={() => setType('ongoing')} className={`col-span-1 flex items-center justify-center pb-[14px] border-b-2 ${type == 'ongoing' ? "border-theme-accent" : "border-theme-gray"} cursor-pointer`}>
                                                <h2 className={`font-semibold lg:text-base text-sm ${type == 'ongoing' ? "text-white dark:text-theme-accent" : "text-theme-gray"}`}>Event Berlangsung</h2>
                                          </div>
                                          <div onClick={() => setType('upcoming')} className={`col-span-1 flex items-center justify-center pb-[14px] border-b-2 ${type == 'upcoming' ? "border-theme-accent" : "border-theme-gray"} cursor-pointer`}>
                                                <h2 className={`font-semibold lg:text-base text-sm ${type == 'upcoming' ? "text-white dark:text-theme-accent" : "text-theme-gray"}`}>Event Selanjutnya</h2>
                                          </div>
                                          <div onClick={() => setType('past')} className={`col-span-1 flex items-center justify-center pb-[14px] border-b-2 ${type == 'past' ? "border-theme-accent" : "border-theme-gray"} cursor-pointer`}>
                                                <h2 className={`font-semibold lg:text-base text-sm ${type == 'past' ? "text-white dark:text-theme-accent" : "text-theme-gray"}`}>Event Berlalu</h2>
                                          </div>
                                    </div>
                                    <div className='px-6 grid lg:grid-cols-3 grid-cols-2 gap-[14px] mt-[14px]'>
                                          {loading ? (
                                                // Skeleton placeholder
                                                Array.from({ length: 6 }).map((_, i) => (
                                                      <div
                                                      key={i}
                                                      className="w-full h-[172px] rounded-[8px] bg-[#292F36] dark:bg-theme-dark_card3"
                                                      ></div>
                                                ))
                                          ) : event.length > 0 ? (
                                                event.map((event, index) => (
                                                      <Link
                                                      href={`/${event.slug}`}
                                                      key={index}
                                                      className='w-full h-[172px] overflow-hidden rounded-[8px] relative group'
                                                      >
                                                      <div className='absolute top-0 left-0 w-full h-full bg-gradient-to-b from-transparent to-black z-10 flex flex-col items-start justify-end p-2'>
                                                            <h2 className='font-bold text-xs text-white opacity-0 group-hover:opacity-100 duration-200'>
                                                                  {event.title}
                                                            </h2>
                                                            <p className='text-[10px] text-theme-gray opacity-0 group-hover:opacity-100 duration-200'>
                                                                  {event.total_page_views} views
                                                            </p>
                                                      </div>
                                                      <Image
                                                            src={event.image}
                                                            alt='poster'
                                                            fill
                                                            className='w-full h-full object-cover rounded-[8px] group-hover:scale-105 duration-500'
                                                      />
                                                      </Link>
                                                ))
                                          ) : (
                                                // Empty state jika tidak ada data
                                                <div className="col-span-full flex flex-col items-center justify-center py-10">
                                                      <p className="text-theme-gray text-sm font-medium">
                                                            Belum ada event untuk kategori ini
                                                      </p>
                                                </div>
                                          )}
                                    </div>
                              </div>
                        </div>
                  </main>
            </div>
      </>
  );
}
